import React, { useState, useEffect } from "react";
import { node_api, producaov2 } from "../../services/apis";
import { Message, Loader, Checkbox } from "semantic-ui-react";
import swal from "sweetalert";
function Verificado(props) {
  const [verificado, setVerificado] = useState(false);
  const [urlCertificado, setUrlCertificado] = useState("");
  const [loading, setLoading] = useState(true);
  const { id_curso, id_aluno, id_licao, nome_licao } = props.info;

  useEffect(() => {
    producaov2.post("/admin/projeto/certificado", { id_curso, id_aluno }).then((v) => {
      setLoading(false);
      setVerificado(v.data.verificado == true);
      setUrlCertificado(v.data.url_certificado);
    });
  }, [id_aluno]);

  async function verificar(action) {
    setLoading(true);
    const data = { id_curso, id_aluno, certificado_inicial: 1 };
    data.certificano_inicial_verificado = action ? 1 : 0;
    const retorno = await producaov2
      .put("projetos", data)
      .then((v) => {
        console.log(v.data);
        setVerificado(action);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
        swal(
          "Ocorreu um erro ao atualizar verificação!",
          "Houve um erro ao salvar os dados do arquivo enviado. Se o erro persistir, nos contate.",
          "error"
        );
        return false;
      });
  }

  function render_button_check() {
    return verificado ? (
      <>
        <span>Retirar verificação</span>
        <Checkbox checked onChange={(e, f) => verificar(f.checked)} toggle />
      </>
    ) : (
      <>
        <span>Verificar:</span>
        <Checkbox onChange={(e, f) => verificar(f.checked)} toggle />
      </>
    );
  }
  return (
    <>
      {loading ? (
        <div class="ui segment">
          <p></p>
          <div class="ui active dimmer">
            <div class="ui small loader"></div>
          </div>
        </div>
      ) : urlCertificado == "" || urlCertificado === undefined ? (
        <Message negative>Não enviado</Message>
      ) : verificado ? (
        <center>
          <Message positive>Verificado</Message>
          {nome_licao.indexOf("Envio de Certificado") > -1 && (
            <>
              <a
                href={urlCertificado.replace(
                  "var/www/html",
                  "https://www.voitto.com.br"
                )}
                target="_blank"
                className="ui small positive button"
              >
                Visualizar
              </a>
              {render_button_check()}
            </>
          )}
        </center>
      ) : (
        <center>
          <Message negative>Não verificado</Message>
          {nome_licao.indexOf("Envio de Certificado") > -1 && (
            <>
              <a
                href={urlCertificado.replace(
                  "var/www/html",
                  "https://www.voitto.com.br"
                )}
                target="_blank"
                className="ui small positive button"
              >
                Visualizar
              </a>
              {render_button_check()}
            </>
          )}
        </center>
      )}
    </>
  );
}

export default Verificado;
